var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWqsr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4634 13.9096H13.5776L14.6404 15.2769L15.686 16.4948L17.6565 18.9652H15.3355L13.9797 17.2991L13.2846 16.311L11.4634 13.9096ZM17.8346 12.1172C17.8346 13.4002 17.5914 14.4918 17.105 15.3918C16.6224 16.2918 15.9637 16.9793 15.1287 17.4542C14.2976 17.9253 13.3631 18.1609 12.3252 18.1609C11.2796 18.1609 10.3413 17.9234 9.51016 17.4485C8.67906 16.9736 8.02222 16.2861 7.53965 15.386C7.05707 14.486 6.81578 13.3964 6.81578 12.1172C6.81578 10.8341 7.05707 9.74259 7.53965 8.84255C8.02222 7.94251 8.67906 7.25694 9.51016 6.78586C10.3413 6.31094 11.2796 6.07348 12.3252 6.07348C13.3631 6.07348 14.2976 6.31094 15.1287 6.78586C15.9637 7.25694 16.6224 7.94251 17.105 8.84255C17.5914 9.74259 17.8346 10.8341 17.8346 12.1172ZM15.3126 12.1172C15.3126 11.2861 15.1881 10.5852 14.9391 10.0145C14.694 9.44386 14.3474 9.01107 13.8993 8.71616C13.4512 8.42125 12.9265 8.2738 12.3252 8.2738C11.7239 8.2738 11.1992 8.42125 10.7511 8.71616C10.303 9.01107 9.95444 9.44386 9.70549 10.0145C9.46037 10.5852 9.33782 11.2861 9.33782 12.1172C9.33782 12.9483 9.46037 13.6492 9.70549 14.2198C9.95444 14.7905 10.303 15.2233 10.7511 15.5182C11.1992 15.8131 11.7239 15.9605 12.3252 15.9605C12.9265 15.9605 13.4512 15.8131 13.8993 15.5182C14.3474 15.2233 14.694 14.7905 14.9391 14.2198C15.1881 13.6492 15.3126 12.9483 15.3126 12.1172Z",
    fill: "url(#paint0_linear_453_1048)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_453_1048",
    x1: 4.92277,
    y1: -2.36623,
    x2: 20.0964,
    y2: -2.1891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7946E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF005C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWqsr);
export default __webpack_public_path__ + "static/media/wqsr.907841ef4d78f70396e667782b65b111.svg";
export { ForwardRef as ReactComponent };